import * as React from 'react';

import {
  Route, Switch
} from 'react-router-dom';

import {
  connect,
} from 'react-redux';

import { 
  HomePage,
  TroughsPage
} from './Pages';

import { NoMatchRoute, QueryParamsDispatcher } from './Container';
import { GlobalPublicState } from 'src/api';

export interface PublicRouterProps {
  authenticator: GlobalPublicState['authenticator'];
  location: GlobalPublicState['router']['location'];
}

class PublicRouter extends React.Component<PublicRouterProps> {
  render() {
    return (
      <main className="route-public">
        <QueryParamsDispatcher />
        <Switch>
          <Route path="/" exact={true} component={HomePage} />
          <Route path="/login" exact={true} component={HomePage} />
          <Route path="/reset-password" exact={true} component={HomePage} />
          <Route path="/reset-password/succeeded" exact={true} component={HomePage} />
          <Route path="/reset-password-change/succeeded" exact={true} component={HomePage} />
          <Route path="/change-password/succeeded" exact={true} component={HomePage} />
          <Route path="/change-email/succeeded" exact={true} component={HomePage} />
          <Route path="/request-password-change" exact={true} component={HomePage} />
          <Route path="/imprint" exact={true} component={HomePage} />
          <Route path="/legals" exact={true} component={HomePage} />
          <Route path="/privacy-policy" exact={true} component={HomePage} />
          <Route path="/register" exact={true} component={HomePage} />
          <Route path="/register/succeeded" exact={true} component={HomePage} />
          <Route path="/register/activate-account" exact={true} component={HomePage} />
          <Route path="/register/resend-activation/succeeded" exact={true} component={HomePage} />
          <Route path="/register/activate-account/succeeded" exact={true} component={HomePage} />
          <Route path="/troughs" exact={true} component={TroughsPage} />
          <Route path="/page-not-found" exact={true} component={HomePage} />
          <Route component={NoMatchRoute} />
        </Switch>
      </main>
    );
  }
}

export default connect((state: GlobalPublicState) => ({
  authenticator: state.authenticator,
  location: state.router.location,
}))(PublicRouter);
